<template>
   <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="container-full">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title">Toplu SMS Gönderimi</h5>

                <div class="row mb-3">
                  <div class="col-md-4">
                    <label class="form-label">Durumlar</label>
                    <SearchableSelect
                      v-model="selectedStatuses"
                      :options="statusOptions"
                      label="label"
                      :reduceFn="s => s.value"
                      multiple
                      searchable
                      placeholder="Durum seçin..."
                    />
                  </div>

                  <div class="col-md-4">
                    <label class="form-label">Tarifeler</label>
                    <SearchableSelect
                      v-model="selectedTariffs"
                      :options="tariffOptions"
                      label="name"
                      :reduceFn="t => t.id"
                      multiple
                      searchable
                      placeholder="Tarife ara..."
                      @input="onTariffsChange"
                    />
                  </div>

                  <div class="col-md-4">
                    <label class="form-label">Mikrotikler</label>
                    <SearchableSelect
                      v-model="selectedRouters"
                      :options="routerList"
                      label="shortname"
                      :reduceFn="r => r.id"
                      multiple
                      searchable
                      placeholder="Mikrotik ara..."
                      @input="onRoutersChange"
                    />
                  </div>
                </div>

                <hr />

                <div class="row mb-3">
                  <div class="col-12 mb-3">
                    <label class="form-label">SMS Gönderici</label>
                    <select class="form-control form-select w-50" v-model="selectedProvider">
                      <option v-for="p in smsProviders" :key="p.value" :value="p.value">{{ p.label }}</option>
                    </select>
                  </div>
                  <div class="col-12 mb-3">
                    <label class="form-label">Mesaj</label>
                    <textarea v-model="message" class="form-control" rows="4" placeholder="Mesajınızı girin"></textarea>
                  </div>
                </div>

                <div class="d-flex justify-content-end">
                  <button class="btn btn-secondary me-2" :disabled="previewing || sending" @click="previewCount">
                    <span v-if="previewing" class="spinner-border spinner-border-sm me-1"></span>
                    Önizle (adet)
                  </button>
                  <button class="btn btn-primary" :disabled="sending || previewing" @click="sendBulk">
                    <span v-if="sending" class="spinner-border spinner-border-sm me-1"></span>
                    Gönder
                  </button>
                </div>
            </div>
        </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import SearchableSelect from "@/components/SearchableSelect";
import { notify } from '@/helpers/notify'

export default {
  page: {
    title: "Toplu SMS",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, SearchableSelect },
  data() {
    return {
      title: 'Toplu SMS',
      items: [ { text: 'ANASAYFA', href: '/' }, { text: 'Toplu SMS', active: true } ],
      numbers: '',
      message: '',
      selectedStatuses: ['1'],
      tariffOptions: [],
      selectedTariffs: ['ALL'],
      routerList: [],
      selectedRouters: ['ALL'],
      statusOptions: [
        { value: '1', label: 'Aktif' },
        { value: '2', label: 'Pasif' },
        { value: '4', label: 'Dondurulmuş' },
        { value: '3', label: 'İptal' }
      ],
      smsProviders: [
        { value: 'postaguvercini', label: 'Posta Güvercini' },
        { value: 'kktcvodafone', label: 'KKTC Vodafone' }
      ],
      selectedProvider: '',
      sending: false,
      previewing: false
    }
  },
  mounted() {
    this.fetchTariffs();
    this.fetchRouters();
    this.fetchSmsProviders();
  },
  methods: {
    buildPayload() {
      return {
        statuses: this.selectedStatuses,
        tariffs: (this.selectedTariffs || []).includes('ALL') ? [] : this.selectedTariffs,
        routers: (this.selectedRouters || []).includes('ALL') ? [] : this.selectedRouters,
        numbers: this.numbers.split(/\r?\n/).map(s => s.trim()).filter(Boolean)
      };
    },
    onTariffsChange(val) {
      if (!Array.isArray(val)) return;
      if (val.includes('ALL')) {
        this.selectedTariffs = ['ALL'];
      } else {
        this.selectedTariffs = val;
      }
    },
    onRoutersChange(val) {
      if (!Array.isArray(val)) return;
      if (val.includes('ALL')) {
        this.selectedRouters = ['ALL'];
      } else {
        this.selectedRouters = val;
      }
    },
    async fetchTariffs() {
      try{
        const resp = await this.$http.post('/tariff?output=one&fields=id,name');
        this.tariffOptions = resp.data || [];
        if (!this.tariffOptions.find(t => t.id === 'ALL')) {
          this.tariffOptions.unshift({ id: 'ALL', name: 'Tüm Tarifeler' });
        }
      }catch(err){ void err }
    },
    async fetchRouters() {
      try{
        const resp = await this.$http.post('/routers', { output: 'only' });
        this.routerList = resp.data.content || [];
        if (!this.routerList.find(r => r.id === 'ALL')) {
          this.routerList.unshift({ id: 'ALL', shortname: 'Tüm Mikrotikler' });
        }
      }catch(err){ void err }
    },
    async fetchSmsProviders() {
      try{
        const resp = await this.$http.get('/settings/sms');
        const data = resp.data || {};
        if (Array.isArray(data.providers) && data.providers.length) {
          this.smsProviders = data.providers.map(p => ({ value: p.value || p.provider || '', label: p.label || p.value || p.provider || '' }));
          const primary = data.providers.find(p => p.is_primary) || data.providers[0];
          this.selectedProvider = (primary && (primary.value || primary.provider)) || '';
        } else {
          const provider = data.sms_provider || data.provider || data.sms || '';
          if (provider) {
            this.smsProviders = [{ value: provider, label: provider }];
            this.selectedProvider = provider;
          }
        }
      }catch(err){ void err }
    },
    async previewCount() {
      this.previewing = true;
      try{
        const res = await this.$http.post('/admin/sms/preview', this.buildPayload());
        const count = (res.data.count ?? res.data) || 0;
        notify.success(`Tahmini alıcı: ${count}`)
      }catch(err){
        void err;
        notify.error('Önizleme başarısız')
      } finally {
        this.previewing = false;
      }
    },
    async sendBulk() {
      if (!this.message.trim()) {
        notify.warning('Mesaj alanı zorunludur')
        return;
      }
      if (!this.selectedProvider) {
        notify.warning('SMS firması seçiniz')
        return;
      }

      this.sending = true;
      const payload = {
        ...this.buildPayload(),
        provider: this.selectedProvider,
        message: this.message
      };
      try{
        const res = await this.$http.post('/admin/sms/send-bulk', payload);
        notify.success(res.data.message || 'İstek gönderildi')
      }catch(err){
        void err;
        notify.error('Gönderim başarısız')
      } finally {
        this.sending = false;
      }
    }
  }
}
</script>

<style scoped>
.card { border: 1px solid #e9ecef }
</style>
